var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 126,
    viewBox: "0 0 190 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.309 38.327C126.506 41.5276 122.557 41.9676 116.231 41.3592C111.474 40.901 107.135 40.5463 102.377 37.9658C99.0468 36.1611 96.4107 33.7192 94.4868 31.3475C92.4019 28.7781 89.4917 25.8459 90.9182 22.9328C92.8788 18.931 104.216 15.5605 115.226 21.0722C127.319 27.1286 130.073 35.1987 128.309 38.327Z",
    fill: "url(#paint0_linear_245_981)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M159.848 64.5586C153.152 67.8626 144.266 63.6143 144.266 63.6143C144.266 63.6143 146.241 54.0114 152.94 50.7121C159.635 47.4081 168.519 51.6518 168.519 51.6518C168.519 51.6518 166.544 61.2547 159.848 64.5586Z",
    fill: "url(#paint1_linear_245_981)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9478 41.575C43.3179 43.5843 48.153 41.7268 48.153 41.7268C48.153 41.7268 47.5207 36.6127 44.1485 34.6057C40.7785 32.5964 35.9453 34.4516 35.9453 34.4516C35.9453 34.4516 36.5776 39.5657 39.9478 41.575Z",
    fill: "url(#paint2_linear_245_981)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M148.282 74.9909C146.527 74.9909 145.104 76.4065 145.104 78.1527C145.104 79.8989 146.527 81.3145 148.282 81.3145C150.038 81.3145 151.461 79.8989 151.461 78.1527C151.461 76.4065 150.038 74.9909 148.282 74.9909Z",
    fill: "#986060"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4147 51.1031C40.9697 51.1031 39.7982 52.2684 39.7982 53.7059C39.7982 55.1433 40.9697 56.3086 42.4147 56.3086C43.8598 56.3086 45.0312 55.1433 45.0312 53.7059C45.0312 52.2684 43.8598 51.1031 42.4147 51.1031Z",
    fill: "#986060"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.442 100.641C53.7963 100.641 52.4622 99.3141 52.4622 97.677C52.4622 96.04 53.7963 94.7129 55.442 94.7129C57.0878 94.7129 58.4219 96.04 58.4219 97.677C58.4219 99.3141 57.0878 100.641 55.442 100.641Z",
    fill: "#986060"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M131.797 63.5605C131.029 63.5605 130.406 62.9412 130.406 62.1772C130.406 61.4133 131.029 60.7939 131.797 60.7939C132.565 60.7939 133.188 61.4133 133.188 62.1772C133.188 62.9412 132.565 63.5605 131.797 63.5605Z",
    fill: "#986060"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0012 27.7679C49.0137 27.7679 48.2133 26.9717 48.2133 25.9894C48.2133 25.0072 49.0137 24.2109 50.0012 24.2109C50.9886 24.2109 51.7891 25.0072 51.7891 25.9894C51.7891 26.9717 50.9886 27.7679 50.0012 27.7679Z",
    fill: "#E1E4E5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.105 73.2004C32.6787 73.2004 31.5225 72.0502 31.5225 70.6314C31.5225 69.2126 32.6787 68.0625 34.105 68.0625C35.5313 68.0625 36.6875 69.2126 36.6875 70.6314C36.6875 72.0502 35.5313 73.2004 34.105 73.2004Z",
    fill: "#E1E4E5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M106.675 103.87C105.59 103.87 104.71 102.995 104.71 101.915C104.71 100.835 105.59 99.96 106.675 99.96C107.761 99.96 108.641 100.835 108.641 101.915C108.641 102.995 107.761 103.87 106.675 103.87Z",
    fill: "#E1E4E5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M139.831 48.6536C138.043 48.6536 136.593 47.2111 136.593 45.4318C136.593 43.6524 138.043 42.21 139.831 42.21C141.62 42.21 143.07 43.6524 143.07 45.4318C143.07 47.2111 141.62 48.6536 139.831 48.6536Z",
    fill: "#E1E4E5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.494 50.6114C25.7745 51.6527 25.1533 52.723 24.1065 53.002C23.0597 53.281 21.9837 52.6631 21.7032 51.6218C21.4227 50.5805 22.0439 49.5101 23.0907 49.2311C24.1375 48.9521 25.2135 49.5701 25.494 50.6114Z",
    fill: "#E1E4E5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8037 30.5156C63.362 30.5156 62.1933 29.353 62.1933 27.9189C62.1933 26.4848 63.362 25.3223 64.8037 25.3223C66.2454 25.3223 67.4141 26.4848 67.4141 27.9189C67.4141 29.353 66.2454 30.5156 64.8037 30.5156Z",
    fill: "#E1E4E5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M161.625 92.1225C160.516 92.1225 159.617 91.4071 159.617 90.5246C159.617 89.6422 160.516 88.9268 161.625 88.9268C162.734 88.9268 163.633 89.6422 163.633 90.5246C163.633 91.4071 162.734 92.1225 161.625 92.1225Z",
    fill: "#E1E4E5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2825 103.884C91.8663 106.051 90.5734 108.278 88.3947 108.859C86.2161 109.44 83.9767 108.154 83.3929 105.987C82.8092 103.819 84.1021 101.592 86.2807 101.011C88.4594 100.43 90.6987 101.716 91.2825 103.884Z",
    fill: "#E1E4E5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2478 66.3662H58.3003C58.6115 70.7504 61.8892 70.818 61.8892 70.818C61.8892 70.818 58.2748 70.8881 58.2748 75.9542C58.2748 70.8881 54.6604 70.818 54.6604 70.818C54.6604 70.818 57.9368 70.7504 58.2478 66.3662ZM47.5242 81.1452H47.5516C47.7142 83.5255 49.428 83.5621 49.428 83.5621C49.428 83.5621 47.5383 83.6003 47.5383 86.3507C47.5383 83.6003 45.6484 83.5621 45.6484 83.5621C45.6484 83.5621 47.3616 83.5255 47.5242 81.1452Z",
    fill: "#E1E4E5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M82 48.6287V39.3593C82 32.5339 87.5632 27 94.4247 27C101.286 27 106.849 32.5339 106.849 39.3593V48.6287",
    stroke: "#986060",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.603 92.4039H75.8374C71.7747 92.4039 68.4844 89.1306 68.4844 85.0894V59.4891C68.4844 55.4481 71.7747 52.1748 75.8374 52.1748H112.603C116.665 52.1748 119.956 55.4481 119.956 59.4891V85.0894C119.956 89.1306 116.665 92.4039 112.603 92.4039Z",
    fill: "#986060",
    stroke: "#986060",
    strokeWidth: 17.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9774 81.0641V71.8913M93.9671 66.4277C92.4699 66.4277 91.2549 67.6363 91.2657 69.1256C91.2657 70.6147 92.4806 71.8235 93.9778 71.8235C95.475 71.8235 96.69 70.6147 96.69 69.1256C96.69 67.6363 95.475 66.4277 93.9671 66.4277",
    stroke: "white",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9041 26.7168H28.5512C24.2082 26.7168 20.6875 30.2189 20.6875 34.539C20.6875 38.8591 24.2082 42.3612 28.5512 42.3612H64.9041C69.2471 42.3612 72.7678 38.8591 72.7678 34.539C72.7678 30.2189 69.2471 26.7168 64.9041 26.7168Z",
    fill: "url(#paint3_linear_245_981)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0603 20.8184H33.7074C29.3644 20.8184 25.8438 24.3205 25.8438 28.6405C25.8438 32.9606 29.3644 36.4627 33.7074 36.4627H70.0603C74.4033 36.4627 77.924 32.9606 77.924 28.6405C77.924 24.3205 74.4033 20.8184 70.0603 20.8184Z",
    fill: "#453737"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M35.207 30.8404H36.3645L36.2526 29.1839L37.647 30.1127L38.2236 29.1024L36.7262 28.3748L38.2236 27.6471L37.647 26.6368L36.2526 27.5659L36.3645 25.9092H35.207L35.3147 27.5659L33.9205 26.6368L33.3438 27.6471L34.8456 28.3748L33.3438 29.1024L33.9205 30.1127L35.3147 29.1839L35.207 30.8404ZM43.2588 30.8404H44.4163L44.3044 29.1839L45.6986 30.1127L46.2751 29.1024L44.7777 28.3748L46.2751 27.6471L45.6986 26.6368L44.3044 27.5659L44.4163 25.9092H43.2588L43.3663 27.5659L41.9721 26.6368L41.3955 27.6471L42.8972 28.3748L41.3955 29.1024L41.9721 30.1127L43.3663 29.1839L43.2588 30.8404ZM51.3104 30.8404H52.4679L52.356 29.1839L53.7502 30.1127L54.3269 29.1024L52.8293 28.3748L54.3269 27.6471L53.7502 26.6368L52.356 27.5659L52.4679 25.9092H51.3104L51.4178 27.5659L50.0236 26.6368L49.4471 27.6471L50.9489 28.3748L49.4471 29.1024L50.0236 30.1127L51.4178 29.1839L51.3104 30.8404ZM59.3619 30.8404H60.5195L60.4076 29.1839L61.8019 30.1127L62.3785 29.1024L60.8809 28.3748L62.3785 27.6471L61.8019 26.6368L60.4076 27.5659L60.5195 25.9092H59.3619L59.4696 27.5659L58.0754 26.6368L57.4987 27.6471L59.0005 28.3748L57.4987 29.1024L58.0754 30.1127L59.4696 29.1839L59.3619 30.8404ZM67.4135 30.8404H68.5712L68.4593 29.1839L69.8535 30.1127L70.4301 29.1024L68.9326 28.3748L70.4301 27.6471L69.8535 26.6368L68.4593 27.5659L68.5712 25.9092H67.4135L67.5212 27.5659L66.127 26.6368L65.5502 27.6471L67.0521 28.3748L65.5502 29.1024L66.127 30.1127L67.5212 29.1839L67.4135 30.8404Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.248 89.4628C141.248 98.2555 134.594 106.477 125.652 108.473C116.709 106.477 110.055 98.2555 110.055 89.4628V82.5561C110.055 81.7868 110.286 81.035 110.717 80.3966C111.149 79.7582 111.762 79.2623 112.478 78.972L122.226 75.0103C124.422 74.1176 126.882 74.1176 129.077 75.0103L138.825 78.972C139.541 79.2624 140.154 79.7585 140.586 80.3968C141.017 81.0351 141.248 81.7868 141.248 82.5561V89.4628Z",
    fill: "#453737"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M131.983 87.4473L124.684 94.708L120.305 90.3516",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_245_981",
    x1: 116.163,
    y1: 59.071,
    x2: 100.254,
    y2: -12.7965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_245_981",
    x1: 134.136,
    y1: 74.8644,
    x2: 189.137,
    y2: 31.1283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_245_981",
    x1: 52.9894,
    y1: 48.0428,
    x2: 26.0044,
    y2: 22.8375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_245_981",
    x1: 47.8381,
    y1: 51.1324,
    x2: 47.6931,
    y2: 9.69335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.53e8a4c6be75720ad45c6473b848042f.svg";
export { ForwardRef as ReactComponent };